import { render, staticRenderFns } from "./PodcastCard.vue?vue&type=template&id=22219d84&"
import script from "./PodcastCard.vue?vue&type=script&lang=js&"
export * from "./PodcastCard.vue?vue&type=script&lang=js&"
import style0 from "./PodcastCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports